<template>
  <div class="index-main" v-show="flag">
    <rightTag></rightTag>
    <headers
      @changeFlag="changeFlag"
      @tabClick="tabClick"
      @disTenant="disTenant"
      @teaTabClick="teaTabClick"
      @tabClickFutility="tabClickFutility"
    ></headers>
    <div class="center" v-if="disableTenant.state == 0">
      <menus ref="menus" v-if="!isUserType"></menus>
      <menus
        ref="menus"
        v-else-if="isResources == 1"
        style="height: calc(100vh - 130px)"
      ></menus>

      <contents v-if="!isOuterChain">
        <router-view :key="key" />
      </contents>
      <div v-else class="content img-404-box">
        <div class="img-404"><img src="/img/404.png" alt="" width="30%" /></div>
      </div>
    </div>
    <div v-else class="notAuthor">
      <img src="../assets/notAuthor.png" alt="" />
      <span>{{ disableTenant.tenantDisablePrompt }}</span>
    </div>
  </div>
</template>
<script>
import header from "@/components/layout/header.vue";
import menu from "@/components/layout/menu.vue";
import content from "@/components/layout/content.vue";
import rightTag from "@/components/layout/rightTag.vue";
import { mapGetters } from "vuex";
import packageJson from "../../package.json";
export default {
  components: {
    menus: menu,
    headers: header,
    contents: content,
    rightTag,
  },
  created() {
    this.loading = this.$loading({
      lock: true,
      text: "页面加载中...",
      spinner: "el-icon-loading",
      customClass: "menu-loading",
      background: "#fff",
    });
  },
  computed: {
    ...mapGetters(["is_Work", "GET_MENU_LIST"]),
    key() {
      return this.$route.path;
    },
  },
  data() {
    return {
      loading: false,
      flag: false,
      disableTenant: {
        state: null, // 只有是0的情况下才是有效的
        tenantDisablePrompt: "",
      },
      isOuterChain: false, // 如果第一个链接是404则显示404
      isUserType: null,
      isResources: null,
    };
  },
  mounted() {},
  methods: {
    // 菜单树加载完成
    changeFlag() {
      this.loading.close();
      this.flag = true;
      let userType = localStorage.getItem("userType");
      this.isUserType =
        (userType && JSON.parse(userType)?.[0].userType === 3) ||
        (userType && JSON.parse(userType)?.[0].userType === 4);

      this.isResources = localStorage.getItem("isResources");
      if (this.$route.name != "app" && packageJson.name == "base") {
        const result = this.findParentNodes(this.GET_MENU_LIST);
        if (
          result &&
          result.length &&
          this.$route.fullPath.indexOf("/userInfo/index") == -1
        ) {
          // 需求：v版本没有工作台，需要进入第一个菜单列表中叶子节点为有效节点否则进入个人中心页面
          this.$refs.menus.menuClick(result[result.length - 1], 1);
        } else {
          this.$router.replace("/userInfo/index");
        }
      }
    },
    tabClick(item) {
      this.isOuterChain = false;
      this.$refs.menus.menuClick(item, 1);
    },
    disTenant(res) {
      this.disableTenant = res;
      console.log(this.disableTenant);
    },
    tabClickFutility(val) {
      this.isOuterChain = val;
    },
    // 找到第一个menuUrl是正常的模块的时候
    findParentNodes(data) {
      if (!data || !Array.isArray(data)) {
        return [];
      }
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        if (node.menuDtos && node.menuDtos.length > 0) {
          const result = this.findParentNodes(node.menuDtos);
          if (result.length > 0) {
            return [node, ...result];
          }
        } else if (
          node.menuUrl.split("/").length == 3 &&
          node.menuUrl.indexOf("http:") == -1 &&
          node.menuUrl.indexOf("https:") == -1
        ) {
          return [node];
        }
      }
      return [];
    },
    teaTabClick(item, index) {
      console.log(item);
      this.isResources = null;
      let isResources = localStorage.getItem("isResources");
      this.isResources = isResources;
      if (this.isResources) {
        this.$refs.menus.menuClick(item, 1);
      } else {
        this.isResources = null;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.index-main {
  height: 100%;
  overflow: auto;
  min-width: 1200px;
}
.center {
  display: flex;
  // height: 100% !important;
}
.notAuthor {
  height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    width: 30%;
  }
  span {
    font-size: 14px;
    width: 50%;
    text-align: center;
  }
}
/* .fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-16px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(16px);
} */
.img-404 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  margin-left: 10px;
  background: #fff;
  height: calc(100vh - 61px);
  border-radius: 8px 0px 0px 0px;
}
</style>
